import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-input-check-type',
  templateUrl: './input-check-type.component.html',
  styleUrls: ['./input-check-type.component.css']
})
export class InputCheckTypeComponent extends FieldType {}
